import { adDetector } from "../helpers/zones/ad_detector"
import { renderAdnimation } from "../helpers/zones/adnimation"
import { renderBsa } from "../helpers/zones/bsa"
import { renderOutbrain } from "../helpers/zones/outbrain"
import { renderCarbonAuto } from "../helpers/zones/carbon"
import { hideHidden, showFallback, clear } from "../helpers/zones/zones"

const renderAds = () => {
  renderAdnimation()
  renderBsa()
  renderOutbrain()
}

const renderNoAds = () => {
  renderCarbonAuto()
  hideHidden()
  showFallback()
}

document.addEventListener("turbo:load", () => {
  adDetector(renderAds, renderNoAds)
})

document.addEventListener("turbo:before-cache", clear)
